import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import LanguageSelection from "../../components/LanguageSelection/LanguageSelection";
import backgroundGrid from "../../images/Login/ischebeck-export-deckblatt.jpg";
import Text_de from "../../images/Login/IS_smartTITAN_Login-Registrieren_2_DE.png";
import Text_es from "../../images/Login/IS_smartTITAN_Login-Registrieren_2_ES.png";
import Text_en from "../../images/Login/IS_smartTITAN_Login-Registrieren_2_EN.png";
import "./BasePage.scss";

function BasePage({ children, bubble, size }) {
  const { i18n } = useTranslation();
  const ownSize = Math.max(12 - size, 1);

  return (
    <section className="base-page">
      <div className="container-fluid h-100 p-0">
        <div className="row h-100 g-0">
          <Col md={ownSize} className={"white"}>
            <div className="login-top-logo-wrapper"></div>
            <div className="base-main-image-container">
              <img
                className="base-main-image img-fluid"
                src={
                  i18n.language === "en"
                    ? Text_en
                    : i18n.language === "de-DE"
                      ? Text_de
                      : i18n.language === "es-ES"
                        ? Text_es
                        : Text_en
                }
                alt=""
              />
            </div>
            {/* {bubble} */}
            <div className="base-footer-image-container">
              <img className="base-footer-image" src={backgroundGrid} alt="" />
            </div>
          </Col>

          <Col md={size} className={"yellow"}>
            <div className="row g-0">
              {/* <div className="col-10"></div> */}
              <div className="col-12">
                <div id="LanguageSelection">
                  <LanguageSelection />
                </div>
              </div>
            </div>
            {children}
            {/* <div>
              <img className="bottom-logo" src={titanLogo} alt="" />
            </div> */}
          </Col>
        </div>
      </div>
    </section>
  );
}

export default BasePage;
